import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
      <h2>Introduction</h2>
        <p>
        I specialize in supporting clients as they heal from complex trauma, anxiety, low self-worth, and faith transitions. I also have experience working with individuals and couples as they address insecure attachment and create healthier communication patterns. I am LGBTQ+ affirming and trauma-informed, committed to providing a safe and supportive space for all. Together, we can work to identify root causes of your issues and why you may be feeling stuck. We can create meaningful change, heal from trauma, and learn practical tools to navigate life in a way that feels better.
        </p>
        <p>
        In our work together, I integrate a variety of therapy approaches including Acceptance and Commitment Therapy (ACT), Emotionally Focused Therapy (EFT), somatic therapy, mindfulness, and parts work. My approach is rooted in attachment theory and has been shaped by specialized training in complex trauma to support clients in keeping the past in the past so they can live more fully in the present. My work is grounded in the belief that we all have the capacity to grow and change; I hope to empower others to do just that.
        </p>
        <p>
        Therapy can be a powerful tool for navigating life's difficult moments, and finding the right therapist can make all the difference. If you think we might be a good fit or have more questions for me, please feel free to schedule a phone consultation.
        </p>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
